

export namespace App.Actions {
  export class GetRoles {
    public static readonly type = "[App] Get Application Roles]";
    constructor(userRoles: any[]) { }
  }

  export class GetAllRoles {
    public static readonly type = "[App] Get All Application Roles]";
    constructor(userRoles: any[]) { }
  }

  export class SetRoles {
    public static readonly type = "[App] Set Application Roles]";
    constructor() { }
  }

  /**
   * Validates any existing token against the backend and restores
   * (or clears) session state accordingly. Idempotent once resolved —
   * safe to dispatch from every route guard evaluation, not just once
   * at bootstrap.
   */
  export class InitializeSession {
    public static readonly type = "[App] Initialize Session]";
    constructor() { }
  }

  /**
   * Clears auth-related state on logout, independent of any localStorage
   * clearing the caller also does.
   */
  export class ClearSession {
    public static readonly type = "[App] Clear Session]";
    constructor() { }
  }

  export class SetToken {
    public static readonly type = "[App] Set Token]";
    constructor(public token: string) { }
    //constructor(public username: string, public password: string) {}
  }

  export class GetToken {
    public static readonly type = "[App] Get Token]";
    constructor() { }
  }


  export class SetOrganizations {
    public static readonly type = "[App] Set Organizations]";
    constructor(public organizations: any[]) { }
  }

  export class SetCurrentOrganization {
    public static readonly type = "[App] Set CurrentOrganization]";
    constructor(public organization: any) { }
  }


  export class GetOrganizations {
    public static readonly type = "[App] Get Organizations]";
    constructor() { }
  }

  export class SetHasOrganization {
    public static readonly type = "[App] Set HasOrganization]";
    constructor(public hasOrganization: boolean) { }
    //constructor(public username: string, public password: string) {}
  }

  export class GetHasOrganization {
    public static readonly type = "[App] Get HasOrganization]";
    constructor() { }
  }


  export class GetActions {
    public static readonly type = "[App] Get Application Actions]";
    constructor() { }
  }


  export class SetActions {
    public static readonly type = "[App] Set Application Actions]";
    constructor() { }
  }

  export class GetTransactionTypes {
    public static readonly type = "[App] Get Application Transaction Types]";
    constructor() { }
  }
}
